module.exports = "/fast-coin/img/coin/coin_start_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/coin_start_1.png
// module id = 2380
// module chunks = 5